var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
export const Frame = (_a) => {
    var { children, className, el: El = 'div', header } = _a, props = __rest(_a, ["children", "className", "el", "header"]);
    React.useEffect(() => {
        document.body.classList.add('of-hidden');
        return () => document.body.classList.remove('of-hidden');
    }, []);
    /*
     * Hacky way of handling with mobile Chrome's head and 100vh layout.
     * To be removed after Chrome to support dvh units.
     */
    React.useEffect(() => {
        const isHackRequired = !is100dvhSupported();
        isHackRequired && frameParentsAddClass('with-frame-inside');
        return () => isHackRequired && frameParentsRemoveClass('with-frame-inside');
    }, []);
    return (React.createElement(El, Object.assign({ className: classnames('Frame', className), "data-anvil-component": "Frame" }, props),
        header && React.createElement("div", { className: "Frame__header" }, header),
        React.createElement("div", { className: "Frame__content" }, children)));
};
const getFrameParents = () => {
    const frame = document.querySelector('[data-anvil-component=Frame]');
    if (!frame)
        return [];
    return [
        ...(function* (e) {
            // eslint-disable-next-line no-param-reassign
            while ((e = e.parentElement)) {
                yield e;
            }
        })(frame),
    ];
};
const frameParentsAddClass = (className) => getFrameParents().forEach((parent) => parent.classList.add(className));
const frameParentsRemoveClass = (className) => getFrameParents().forEach((parent) => parent.classList.remove(className));
const is100dvhSupported = () => {
    try {
        return CSS.supports('height', '100dvh');
    }
    catch (e) {
        return false;
    }
};
//# sourceMappingURL=Frame.js.map